import { Backdrop, Container, Divider, Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ArrowBack, Save as SaveIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { InfoMvmShedCheckout, InfoMvmShedCheckoutUnload } from '../../interfaces/Mvm';
import MvmApi from '../../services/MvmApi';
import ShedApi from '../../services/ShedApi';
import SupplierApi from '../../services/SupplierApi';
import utilsDate from '../../utils/Date';
import MvmRackLoadList from './components/MvmRackLoadList';
import MvmShedList from './components/MvmShedList';
import MvmSummary from './components/MvmSummary';
import ContainerUnload from './ContainerUnLoad';
import { useStyles } from './Style';

interface Params {
  mvmId: string;
  checkoutType: string;
  shedId: string;
  movementTypeId: string;
}

interface IFormInput {
  mvmNumber: any;
  mvmSheds: any;
  sheds?: any;
  mvmRackLoads: any;
  vasilhames: any;
  exitOperatorUserRegistration: any;
}

const ShedCheckout: React.FC = () => {
  const { user } = useAuth();
  const params = useParams<Params>()
  const history = useHistory()
  const classes = useStyles()
  const [circularLoading, setCircularLoading] = useState(false);
  const { t } = useTranslation("Mvm")
  const { t: _t } = useTranslation("General")
  const { t: ts } = useTranslation("MvmShed")
  const { enqueueSnackbar } = useSnackbar()
  const [mvmId, setMvmId] = useState<number>(0)
  const [mvmSupplier, setMvmSupplier] = useState<any>({});
  const [queryMvmId, setQueryMvmId] = useState<any>(null);
  const [exitDate, setExitDate] = useState<any>(null);
  const { isPortoReal } = useAuth();
  const [existingRackLoads, setExistingRackLoads] = useState<any>([]);

  const { control, handleSubmit, setValue, getValues } = useForm<IFormInput>(
    {
      defaultValues: { mvmNumber: {}, mvmSheds: [], mvmRackLoads: [], vasilhames: [] }
    })

  useEffect(() => {
    if (params.mvmId)
      setQueryMvmId(params.mvmId)

    //Armazenar a data exitDate = data em que entrou na tela para digitar os dados
    setExitDate(new Date());
  }, [params.mvmId]);


  const onSummaryChange = async (data: any) => {
    if (!data) {
      setMvmId(0)
      return
    }

    const meansOfMovementList = [{ code: 'E', label: 'Empilhadeira' }, { code: 'P', label: 'Ponte' }];
    setCircularLoading(true)

    let supplierDefault;
    try {
      const suppSearch = await SupplierApi.searchSuppliers([data.suppliers[0].supplierId], user.company.plantID);
      const supp = suppSearch?.items?.[0];

      if (supp) {
        const jitSuffix = supp.systemSuppliers?.[0]?.isJIT ? " - JIT" : " - Não-JIT";
        supplierDefault = {
          label: data.suppliers[0].supplierId + " - " + supp.name + jitSuffix,
          code: data.suppliers[0].supplierId,
          id: data.suppliers[0].supplierId,
          mvmId,
          supplierId: data.suppliers[0].supplierId,
          supplierCorporateName: supp.name + jitSuffix,
          name: supp.name + jitSuffix,
          supplierUf: data.suppliers[0].supplierUF,
          supplierSapCode: supp.supplierSAP,
          sapCode: supp.supplierSAP
        }
      } else {
        supplierDefault = undefined;
      }
    } catch {
      supplierDefault = undefined;
    }

    setMvmId(data.id)
    setMvmSupplier(supplierDefault)

    //Ordernar os sheds para aparecerem na tela baseado na ordem deles (mvmShed.Order)
    data.sheds.sort((a: any, b: any) => { return Number(a.order) - Number(b.order) })

    for (let i = 0; i < data.sheds.length; i++) {
      data.sheds[i].mvmShedId = data.sheds[i].id;
      if (+params.shedId === +data.sheds[i].shedId) {
        if (data.sheds[i].shedCode === '01' && +user.company.plantID === 1) {
          data.sheds[i].meansOfMovement = '';
        } else {
          data.sheds[i].meansOfMovement = meansOfMovementList[0].code;
        }
      }
    }
    await loadShedsRegistrations(data.sheds);
    setValue("mvmRackLoads", data.rackLoads)

    // Armazenar os RackLoads que podem ja existir no Mvm (podem ter sido carregados pelo Logistics)
    // e envia-los para a lista de RackLoads (<MvmRackLoadList />)
    const currentShed = data.sheds.filter((x: any) => Number(x.shedId) === Number(params.shedId) && Number(x.movementTypeId) === Number(params.movementTypeId))[0];
    const shedRackLoads = currentShed?.rackLoads?.filter((x: any) => x.loadType === "R");
    setExistingRackLoads(shedRackLoads);

    setCircularLoading(false)
  }

  const onSubmit = (data: any) => { SubmitData(data, false) }
  const SubmitData = (data: any, allow: boolean) => {
    if (mvmId === 0) {
      enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
      return
    }
    setCircularLoading(true)

    if (params.checkoutType === 'FinishLoad') {
      let putObject: InfoMvmShedCheckout = {
        id: mvmId,
        shed: {
          id: 0,
          movementTypeId: 0,
          exitOperatorUserRegistration: "",
          exitOperatorUserName: "",
          exitConferenceUserRegistration: "",
          exitConferenceUserName: "",
          exitDate: "",
          meansOfMovement: "",
          justification: "",
        }
      }

      const shedToSubmit = data?.mvmSheds?.filter((x: any) => Number(x.shedId) === Number(params.shedId) && Number(x.movementTypeId) === Number(params.movementTypeId))[0];
      let rackLoadsToSubmit = data?.mvmRackLoads?.filter((x: any) => Number(x.shedId) === Number(params.shedId) && Number(x.movementTypeId) === Number(params.movementTypeId));

      if (!rackLoadsToSubmit)
        rackLoadsToSubmit = []

      putObject.id = mvmId;
      shedToSubmit.rackLoads = rackLoadsToSubmit;
      putObject.shed = {
        ...shedToSubmit,
        AllowEmptyRackLoads: (allow),
        id: shedToSubmit.mvmShedId, //o FieldArray sobrescreve o id com uma string, entao, repor aqui
        exitDate: utilsDate.ConvertDateToStringYYYYMMDDTHHMMSS(exitDate)
      };
      MvmApi.finishRackLoad(putObject)
        .then(() => {
          enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' })
          history.push('/ShedManage/3'); //Voltar para a pagina de Gerenciar, na 3a aba (Checkout)
        })
        .finally(() => {
          setCircularLoading(false);
        });
      // }
    }
    else if (params.checkoutType === 'FinishUnload') {
      let putObject: InfoMvmShedCheckoutUnload = {
        id: mvmId,
        shed: {
          id: 0,
          movementTypeId: 0,
          exitOperatorUserRegistration: "",
          exitOperatorUserName: "",
          exitConferenceUserRegistration: "",
          exitConferenceUserName: "",
          exitDate: "",
          meansOfMovement: "",
          justification: "",
        },
        vasilhames: [],
      }

      const shedToSubmit = data.mvmSheds.filter((x: any) => Number(x.shedId) === Number(params.shedId) && Number(x.movementTypeId) === Number(params.movementTypeId))[0];

      const vasilhames = data.vasilhames.map((v: any) => {
        v.mvmShedId = shedToSubmit.mvmShedId;
        v.rackTypeId = v.PackingTypeCode.rackTypeId;
        v.rackTypeCode = v.PackingTypeCode.rackTypeCode;
        v.rackTypeDescription = v.PackingTypeCode.rackTypeDescription;
        v.rackQuantity = Number(v.containerAmount);
        v.volumeQuantity = Number(v.volumesAmount);
        return v;
      });

      // if (shedToSubmit.hasNoErrors)
      // {
      putObject.id = mvmId;
      putObject.vasilhames = vasilhames;
      putObject.shed = {
        ...shedToSubmit,
        id: shedToSubmit.mvmShedId, //o FieldArray sobrescreve o id com uma string, entao, repor aqui
        exitDate: utilsDate.ConvertDateToStringYYYYMMDDTHHMMSS(exitDate)
      };

      // setCircularLoading(false);
      // return;

      MvmApi.finishRackUnload(putObject)
        .then(() => {
          enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' })

          if (data.mvmType === "EKamban" && shedToSubmit.shedType === "D" && shedToSubmit.order === 1)
            history.push(`/AddMvmShed/${queryMvmId}`); //Qdo o mvm for do tipo ekanban  e for o primeiro galpão de descarga e o fornecedor de envio estiver configurado para incluir galpão de carga 
          else
            history.push('/ShedManage/3'); //Voltar para a pagina de Gerenciar, na 3a aba (Checkout)
        }).catch(() => {
          setCircularLoading(false);
        })
        .finally(() => {
          setCircularLoading(false);
        });
      // }
    }
  }

  const loadShedsRegistrations = async (shedList: [any]) => {
    if (params.shedId) {
      let sheRegs_: any[] = [];
      await ShedApi.searchregistration({ shedIds: [+params.shedId], movementTypeId: params.movementTypeId, pageSize: 1000 }).then((response) => {
        //Construir para cada Shed deste componente, um objeto com shedId e lista de matriculas relacionadas a este shedId
        var shedRegs = shedList.map((x: any) => { return { ...x, registrations: [] } });

        //Para cada matricula da api, incluir ela na lista do shed relacionado:
        if (response && response.items) {
          for (let i = 0; i < shedRegs.length; i++) {
            shedRegs[i].registrations = response.items
              .filter((x: any) => +x.shedId === +shedRegs[i].shedId && +x.movementTypeId === +shedRegs[i].movementTypeId)
              .map((x: any) => ({ ...x, code: x.registrationUser, label: x.registrationUser + " - " + x.registrationUserName })); //ja deixar no formato certo pro <Select>
          }

          sheRegs_ = shedRegs.map((item: any, index: number) => {
            let registrations = [];
            const filterRegs = shedRegs.filter((x: any) => x.shedId === item.shedId).map((x: any) => x.registrations);
            if (filterRegs && filterRegs.length > 0)
              registrations = filterRegs[0];

            if (registrations.length === 1 && +params.shedId === item.shedId) {
              //exitOperator
              item.exitOperator = registrations[0];
              item.exitOperatorUserRegistration = registrations[0].registrationUser;
              item.exitOperatorUserName = registrations[0].registrationUserName;

              //exitConference
              item.exitConference = registrations[0];
              item.exitConferenceUserRegistration = registrations[0].registrationUser;
              item.exitConferenceUserName = registrations[0].registrationUserName;

            }

            return item;
          });
        }
      });

      setValue("mvmSheds", sheRegs_);

    }
  }

  return (
    <Container maxWidth={false} component="main">
      <Backdrop style={{ zIndex: 99999 }} open={circularLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <PageTitle title={params.checkoutType === 'FinishLoad' ? t("titleFinishLoad") : t("titleFinishUnload")} />

      <div className={classes.rootContent}>
        <form onSubmit={handleSubmit(onSubmit)} >
          <Divider style={{ marginTop: '10px' }} />
          <MvmSummary
            control={control}
            name={"summary"}
            showAutoComplete={false}
            onChange={onSummaryChange}
            setValue={setValue}
            queryMvmId={queryMvmId}
            includeProperties={["Sheds", "Suppliers"]}
          />
        </form>

        {mvmId === 0 ? <></> :
          <Grid container spacing={1}>
            <Grid item xs={12}>
              {
                <>
                  <MvmShedList
                    control={control}
                    name={"mvmSheds"}
                    title={ts('signatures')}
                    currentShedId={Number(params.shedId)}
                    currentMovTypeId={Number(params.movementTypeId)}
                    editAll={false}
                    validatefields={params.checkoutType === 'FinishUnload'}
                    // shedRegistrations={shedRegistrations}
                    showColumns={["shedCode", "checkInDate", "entryDate", "entryUser", "exitDate", "exitOperatorUser", "exitConferenceUser", "meansOfMovement", "justification"]}
                  />

                  {params.checkoutType === 'FinishLoad' && (
                    <MvmRackLoadList
                      control={control}
                      name={"mvmRackLoads"}
                      title={t('titleMvmRackLoad')}
                      allowAdd={true}
                      allowDelete={true}
                      allowRequestNumberEdit={false}
                      showColumns={isPortoReal() ? ['shedCode', "rackTypeVolume"] : ['shedCode', 'transportOrder', 'fullRack', "rackTypeVolume"]}
                      shedId={params.shedId}
                      movementTypeId={params.movementTypeId}
                      defaultSupplier={mvmSupplier}
                      rackTypes={existingRackLoads}
                      key={existingRackLoads} // para forcar atualizar a view quando carregar os dados do mvm
                    />
                  )}


                  {params.checkoutType === 'FinishUnload' &&
                    (
                      <Grid item xs={12}>
                        <ContainerUnload
                          control={control}
                          name={"vasilhames"}
                        />
                      </Grid>
                    )}

                </>
              }
            </Grid>
            <Grid item xs={12} style={{ marginRight: 30 }}>
              <ButtonUI
                style={{ marginTop: 15 }}
                variant="outlined"
                color="secondary"
                onClick={() => history.replace('/ShedManage/3')}
                startIcon={<ArrowBack />}>
                {'Voltar '}
              </ButtonUI>
              <ButtonUI
                style={{ marginTop: 15, marginLeft: 15 }}
                variant="outlined"
                color="primary"
                onClick={() => SubmitData(getValues(), false)}
                startIcon={<SaveIcon />}>
                {_t("save")}
              </ButtonUI>
              {params.checkoutType === 'FinishLoad' && <ButtonUI
                style={{ marginTop: 15, float: 'right' }}
                variant="outlined"
                color="primary"
                onClick={() => SubmitData(getValues(), true)}>
                {ts("release empty vehicle")}
              </ButtonUI>}
            </Grid>
          </Grid>
        }
      </div>
    </Container>
  )
}
export default ShedCheckout;
